import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const CazebooIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        id="Cazeboo"
        data-name="Cazeboo"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 176.82 150.01"
        strokeWidth={0}
        fill="currentColor"
      >
        <path
          fill={themeColor === 'light' ? '#4d4b4b' : '#fff'}
          d="m13.41,75.01c0-28.75,22-49.13,51.97-49.13,17.41,0,31.45,6.34,40.63,17.82l-17.01,15.39c-5.94-7.15-13.23-11.07-22.27-11.07-15.52,0-26.32,10.8-26.32,27s10.8,27,26.32,27c9.04,0,16.33-3.91,22.27-11.07l17.01,15.39c-9.18,11.47-23.22,17.82-40.63,17.82-29.97,0-51.97-20.38-51.97-49.13Z"
        />
        <g>
          <rect
            fill="#38A0AD"
            x="111.59"
            y="45.15"
            width="49.71"
            height="15.59"
            rx="7.8"
            ry="7.8"
          />
          <rect
            fill="#38A0AD"
            x="96.56"
            y="68.47"
            width="48.52"
            height="15.59"
            rx="7.8"
            ry="7.8"
          />
          <rect
            fill="#38A0AD"
            x="113.7"
            y="91.78"
            width="49.71"
            height="15.59"
            rx="7.8"
            ry="7.8"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default CazebooIcon;
